import React, { useState } from "react";
import imgsrc1 from "../../assets/Landing/imgsrc1.png";
import imgsrc2 from "../../assets/Landing/imgsrc2.png";
import imgsrc3 from "../../assets/Landing/imgsrc3.png";
import imgsrc4 from "../../assets/Landing/imgsrc4.png";
import imgsrc5 from "../../assets/Landing/imgsrc5.png";

const SectionData = () => {
  const [activeIndex, setActiveIndex] = useState(0);

  const accordionData = [
    {
      title: "Step 1: Register your account",
      content:
        "Register your account on Naayatrade with your business details like company name, GST No. etc",
      imageUrl: imgsrc1,
    },
    {
      title: "Step 2: Get verified",
      content:
        "Submit required documents like GST Certificate, Aadhar Card, PAN details and get verified in 24 hours",
      imageUrl: imgsrc2,
    },
    {
      title: "Step 3: List your products",
      content:
        "List your products by providing product and brand details, images, title, description, and price",
      imageUrl: imgsrc3,
    },
    {
      title: "Step 4: Get Business Enquiries",
      content:
        "Get business inquiries via product Inquiry, RFQ, and via Buy Leads",
      imageUrl: imgsrc4,
    },
    {
      title: "Step 5: Complete orders & get paid",
      content:
        "Deliver orders to customers on time and get paid 100% amount within 7 days of delivery",
      imageUrl: imgsrc5,
    },  
  ];

  const handleSliderChange = (event) => {
    const value = parseInt(event.target.value);
    setActiveIndex(value);
  };

  return (
    <div className="w-full h-[597px] m-auto bg-white">
      <div className="h-[597px] m-auto p-12">
        <p className="w-[283px] h-[40px] text-[20px] text-[#FF6300] font-semibold">
          How to sell on Naayatrade?
        </p>
        <div className="w-[1140px] h-[400px] flex justify-between">
          {/* Accordion Content */}
          <div className="w-1/2 pr-4 relative">
            <div className="mt-4 flex">
             <div className="relative h-[400px] w-[15px] bg-gray-300 rounded-lg overflow-hidden">
                <div className="absolute top-0 left-0 h-full w-full bg-gray-300 rounded-lg"></div>
                <div
                  className="absolute left-0 w-full bg-orange-500 rounded-lg"
                   style={{
                    top: `${(activeIndex / (accordionData.length - 1)) * 100}%`,
                     height: `${100 / accordionData.length}%`,
                  }}
                />
              </div>

              <div className=" ml-4 flex-grow">
                {accordionData.map((item, index) => (
                  <div key={index}>
                    <div onClick={() => setActiveIndex(index)} className="p-4">
                      <span className="text-lg font-medium">{item.title}</span>
                    </div>
                    {activeIndex === index && (
                      <div className="p-4 text-gray-700">
                        <p>{item.content}</p>
                      </div>
                    )}
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* Image Display on the Right Side */}
          <div className="flex justify-center items-center">
            {accordionData[activeIndex] && (
              <img
                src={accordionData[activeIndex].imageUrl}
aq                alt={`Image for ${accordionData[activeIndex].title}`}
                className="w-[449px] h-[268px]"
              />
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default SectionData;
